import { useLocation } from "react-router-dom";

export const useLocationHook = () => {
  const location = useLocation();

  return { currentUrl: location.pathname };
};
